<script setup>
import SectionViewer from '../../components/SectionViewer.vue'

// Define sections
const sections = [
  { id: 'participa-descripcion', title: '6.1 Participa (Descripción general)' },
  { id: 'diagnostico-necesidades', title: '6.2 Participación para el diagnóstico de necesidades' },
  { id: 'planeacion-participativa', title: '6.3 Planeación y presupuesto participativo' },
  { id: 'consulta-ciudadana', title: '6.4 Consulta ciudadana' },
  { id: 'colaboracion-innovacion', title: '6.5 Colaboración e innovación abierta' },
  { id: 'rendicion-cuentas', title: '6.6 Rendición de cuentas' },
  { id: 'control-social', title: '6.7 Control social' }
]
</script>

<template>
  <SectionViewer :sections="sections" title="6. Participa" />
</template>
